import axios from "axios";
import { useState } from "react";
import { BASE_URL } from "../../api";
import { Link, redirect, useNavigate } from "react-router-dom";
import MessageToster from "../../component/MessageToster";
// import Loader from "../../component/Loader";
import { EMAIL_REGEX } from "../../utils/regex";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [verror, setVerror] = useState('');
  const [errors, setErrors] = useState({});

  const [input, setInput] = useState({
    email: "",
  })
  // const [validations, setValidations] = useState({
  //   email: '',
  // });
  // const validationRules = {
  //   email: 'email is required',
  // };

  const handelChange = (e) => {
    const { name, value } = e.target;

    setInput({ ...input, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // const handelChange = (e) => {
  //   const { name, value } = e.target;
  //   setInput({ ...input, [name]: value });
  //   setValidations({ ...validations, [name]: false });
  // };

  const validateForm = () => {
    const newErrors = {};

    if (!input.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!EMAIL_REGEX.test(input.email.trim())) {
      newErrors.email = "Enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      onSubmitForm(e);
    }
  };

  const onSubmitForm = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (loading) return;

    if (!validateForm()) return;

    await forgotPassword();
  };

  // const onSubmitForm = async (e) => {
  //   e.preventDefault();
  //   for (const field in input) {
  //     if (!input[field]) {
  //       setValidations({ ...validations, [field]: true });
  //       setVerror(validationRules[field]);
  //       return;
  //     }

  //     if (field === 'email' && !EMAIL_REGEX.test(input.email)) {
  //       setValidations({ ...validations, email: true });
  //       setVerror('Valid Email Required.');
  //       return;
  //     }
  //   }
  //   setLoading(true);
  //   forgotPassword();
  // };

  const forgotPassword = async () => {

    setLoading(true);

    const bodyData = {
      email: input.email.trim(),
      otype: "",
      mode: ""
    };

    try {
      const res = await axios.post(`${BASE_URL}/account/forgot_password`, bodyData, {
        headers: { "Content-Type": "application/json" }
      });

      if (res.data.code === 200) {
        // setLoading(false);
        MessageToster("success", res.data.message);

        sessionStorage.setItem('resetEmail', input.email.trim());
        navigate("/reset_password");

        setInput({ email: '' });
      } else {
        // setLoading(false);
        MessageToster('error', res.data.message);
      }

    } catch (err) {
      // setLoading(false);
      MessageToster("error", err.message)
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="account-pages login-pages">
        <div className="container">
          <div className="row justify-content-center w-100 mx-auto">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card overflow-hidden">
                <div className="bg-primary-subtle">
                  <div className="row">
                    <div className="col-md-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Reset Password</h5>
                        <p>Reset Password with crm.</p>
                      </div>
                    </div>
                    <div className="col-md-5 align-self-end d-none d-md-block">
                      <img
                        src="assets/images/profile-img.png"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src="assets/images/logo-light.svg"
                            alt=""
                            className="rounded-circle"
                            height={34}
                          />
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src="assets/images/logo.svg"
                            alt=""
                            className="rounded-circle"
                            height={34}
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <form onSubmit={onSubmitForm}>
                      <div className="form-horizontal">
                        <div className="mb-3">
                          <label htmlFor="useremail" className="form-label">
                            Email
                          </label>
                          <input
                            className="form-control"
                            type="email"
                            placeholder="Enter Your Email"
                            id="email"
                            autoComplete="off"
                            value={input.email}
                            onChange={handelChange}
                            onKeyDown={handleKeyDown}
                            disabled={loading}
                            name="email"
                          />
                          {errors.email && (
                            <div className="text-danger small mt-1 d-flex align-items-center">
                              <i className="bx bx-info-circle me-1 font-size-14"></i>
                              <span>{errors.email}</span>
                            </div>
                          )}

                          {/* {validations.email &&
                            verror && <>
                              <p className='text-danger mb-0'>{verror}</p>
                            </>
                          } */}
                        </div>
                        {/* <button
                          className="btn btn-primary waves-effect waves-light"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Sending..." : "Reset Password"}
                        </button> */}

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary waves-effect waves-light"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span>Sending...</span>
                              </>
                            ) : (
                              "Reset Password"
                            )}
                          </button>
                        </div>
                        <div className="mt-4 text-center">
                          <p>

                            <Link
                              className="fw-medium text-primary ps-2 "
                              to="/"
                            >
                              <i className="mdi mdi-arrow-left me-1" /> Back to Login
                            </Link>
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
